import { saveCallErrorLog as saveCallErrorLogApi } from '@/api/log'
import { getUser } from '@/utils/auth'

export const getSessionLogData = (session) => {
  if (!session) return null

  const request = session._request
  return {
    id: session._id,
    status: session._status,
    start_time: session._start_time,
    direction: session._direction,
    cancel_reason: session._cancel_reason,
    is_canceled: session._is_canceled,
    is_confirmed: session._is_confirmed,
    late_sdp: session._late_sdp,
    localMediaStream: session._localMediaStream,
    localMediaStreamLocallyGenerated: session._localMediaStreamLocallyGenerated,
    rtcAnswerConstraints: session._rtcAnswerConstraints,
    audioMuted: session._audioMuted,
    request: {
      call_id: request.call_id,
      body: request.body,
      data: request.data,
      cseq: request.cseq,
      server_transaction: {
        last_response: request?.server_transaction?.last_response,
      },
    },
  }
}

class CallEventLog {
  constructor() {
    this.callIds = new Set()
    this.eventsByCallId = {}
    this.sipEvents = []
    this.wsEvents = []
  }

  clear() {
    this.callIds = new Set()
    this.eventsByCallId = {}
    this.sipEvents = []
    this.wsEvents = []
  }

  addSipEvent(name, data) {
    const eventLog = {
      time: new Date().toISOString(),
      name,
      data,
    }

    this.sipEvents.push(eventLog)
    if (this.sipEvents.length > 50) {
      this.sipEvents.shift()
    }
  }

  addWsEvent(name, data) {
    const eventLog = {
      time: new Date().toISOString(),
      name,
      data,
    }

    this.wsEvents.push(eventLog)
    if (this.wsEvents.length > 50) {
      this.wsEvents.shift()
    }
  }

  addEventByCallId(callId, event) {
    if (!this.eventsByCallId[callId]) {
      this.eventsByCallId[callId] = []
    }

    const eventLog = {
      time: new Date().toISOString(),
      event,
    }
    this.eventsByCallId[callId].push(eventLog)
  }

  async sendSingleEvent(cause, event) {
    const user = getUser()
    if (!user) return

    const log = {
      created_at: new Date().toISOString(),
      cause,
      tenant_id: user.tenant_id,
      user_id: user._id,
      agent_id: user.agent_id,
      call_type: null,
      call_ids: [],
      events: [event],
      sip_events: this.sipEvents,
      ws_events: this.wsEvents,
      device: 'web',
      version: '10',
    }
    try {
      await saveCallErrorLogApi(log)
    } catch (e) {
      console.error('Error saving call error log', e)
    }
  }

  async sendEventByCallId(cause, callId) {
    const events = this.eventsByCallId[callId]
    if (!events || events.length === 0) return

    const user = getUser()
    if (!user) return

    const log = {
      created_at: new Date().toISOString(),
      cause,
      tenant_id: user.tenant_id,
      user_id: user._id,
      agent_id: user.agent_id,
      call_type: null,
      call_ids: [callId],
      events,
      sip_events: this.sipEvents,
      ws_events: this.wsEvents,
      device: 'web',
      version: '10',
    }

    try {
      await saveCallErrorLogApi(log)
    } catch (e) {
      console.error('Error sending event to server', e)
    }
  }
}

const callEventLog = new CallEventLog()

export default callEventLog
